import React from 'react';
import { Button } from '@lightspeed/flame/Button';
import Group from '@lightspeed/cirrus-group';
import Modal, { ModalHeader, ModalBody, ModalFooter } from '@lightspeed/cirrus-modal';
import Text from '@lightspeed/cirrus-text';
import { useEventLog } from './use-event-log';
import { errorReasons } from '../utils';
import { modalSteps } from '..';

const errorReasonsMessages = {
  [errorReasons.AGE]: "Customer's age cannot be verified.",
  [errorReasons.MIN_AGE]: 'Customer does not meet the minimum age to purchase.',
  [errorReasons.EXPIRED]: 'Customer ID is expired.',
  [errorReasons.PIN]: 'The PIN you entered is incorrect.',
  [errorReasons.RIGHTS]: "You don't have access to manager verification.",
};

const errorReasonsHeader = {
  [errorReasons.PIN]: 'Incorrect PIN',
  [errorReasons.RIGHTS]: 'Manager PIN required',
};

const AgeVerificationError = ({ setStepWithData, close, stepData = {} }) => {
  const { submitEvent } = useEventLog();

  React.useEffect(() => {
    if (!stepData.reason) return;
    submitEvent(stepData.reason);
  });
  return (
    <Modal className="cirrus responsive" isOpen onRequestClose={close}>
      <ModalHeader onCloseClicked={close}>
        {errorReasonsHeader[stepData.reason] || 'Age verification failed'}
      </ModalHeader>
      <ModalBody>
        {errorReasonsMessages[stepData.reason] ? (
          <Text>{errorReasonsMessages[stepData.reason]}</Text>
        ) : null}
        {!errorReasonsMessages[stepData.reason] && stepData.message ? (
          <Text style={{ maxWidth: '550px' }}>{stepData.message}</Text>
        ) : null}
        {![errorReasons.PIN, errorReasons.RIGHTS].includes(stepData.reason) ? (
          <Text>The age-restricted item cannot be added to the sale.</Text>
        ) : null}
      </ModalBody>
      <ModalFooter>
        <Group className="cr-justify-end">
          {[errorReasons.PIN, errorReasons.RIGHTS].includes(stepData.reason) ? (
            <Button
              onClick={() =>
                setStepWithData({ step: modalSteps.AGE_VERIFICATION_MANUAL, data: stepData })
              }
            >
              Try again
            </Button>
          ) : null}
          <Button variant="primary" fill onClick={close}>
            Back to sale
          </Button>
        </Group>
      </ModalFooter>
    </Modal>
  );
};

export default AgeVerificationError;
